var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnalyzerTable',{attrs:{"headers":_vm.missingCorridorsTableHeaders,"get-table-data-action":"AnalyzerStore/getMissingCorridors","table-data-getter":"AnalyzerStore/missingCorridors"}})}
var staticRenderFns = []

export { render, staticRenderFns }